import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback, useMemo } from "react";
import styled from "styled-components";
import { Formik, Form } from "formik";
import ModalSubmit from "components/common/ModalSubmit";
import loadAsync from "routing/loadAsync";
import useUserDateTime from "hooks/useUserDateTime";
import useTimeRangeValidation from "views/components/time-range-picker/useTimeRangeValidation";
import { filterValueToTimeRangePickerFormValues, timeRangePickerFormValuesToFilterValue } from "../helpers/timeRange";
const TimeRangePickerFormContent = loadAsync(
  () => import("views/components/time-range-picker/TimeRangePickerFormContent")
);
const Container = styled.div`
  padding: 3px 10px;
  width: 735px;
`;
const DateRangeForm = ({ filter, onSubmit }) => {
  const { t } = useTranslation("common");
  const { formatTime, userTimezone } = useUserDateTime();
  const validate = useTimeRangeValidation();
  const initialValues = useMemo(
    () => filterValueToTimeRangePickerFormValues(filter == null ? void 0 : filter.value, formatTime),
    [filter == null ? void 0 : filter.value, formatTime]
  );
  const _onSubmit = useCallback(
    (values) => {
      const serializedFilter = timeRangePickerFormValuesToFilterValue(values, userTimezone, formatTime);
      onSubmit(serializedFilter);
    },
    [formatTime, onSubmit, userTimezone]
  );
  return /* @__PURE__ */ React.createElement(Container, { "data-testid": "time-range-form" }, /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues,
      onSubmit: _onSubmit,
      enableReinitialize: true,
      validate
    },
    ({ isValid }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(TimeRangePickerFormContent, { limitDuration: 0 }, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        disabledSubmit: !isValid,
        submitButtonText: filter ? t("filters.update_submit") : t("filters.create_submit"),
        bsSize: "small",
        displayCancel: false
      }
    )))
  ));
};
export default DateRangeForm;
